// extracted by mini-css-extract-plugin
export default {"newsList":"PostDetail_newsList__tnoN0","postDate":"PostDetail_postDate__GpuWb","postTitle":"PostDetail_postTitle__Ju-c8","postImg":"PostDetail_postImg__gZkG0"};